export enum FundSourceTypeEnum {
    /**
     * The fund source is a credit/debit card.
     */
    creditCard = 1,
    /**
     * The fund source is a bank account.
     */
    bankAccount = 2,
    /**
     * The fund source is the Ping balance. Cannot be used in a purchase or top up. In a purchase use UseBalance = true instead.
     */
    pingBalance = 3,
    /**
     * The fund source is the Loyalty Subscription.
     */
    tmLoyalty = 4,
    /**
     * The fund source is Open Banking.
     */
    openBank = 5
}
